import React from 'react';
import { components } from 'react-select';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EventsSectionDescription(_ref) {
  var _config$events, _config$events2, _config$events3, _config$events4;
  var pastEvents = _ref.pastEvents,
    selectedCategories = _ref.selectedCategories,
    onFilterClick = _ref.onFilterClick,
    type = _ref.type,
    config = _ref.config,
    color = _ref.color,
    ComponentsRenderer = _ref.ComponentsRenderer,
    FilterOptions = _ref.FilterOptions;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col justify-center text-accent-content",
    children: [/*#__PURE__*/_jsx("h1", {
      className: "self-center text-center text-black\n    ".concat(config === null || config === void 0 || (_config$events = config.events) === null || _config$events === void 0 ? void 0 : _config$events.fontHeading, " \n   \n    ").concat((config === null || config === void 0 || (_config$events2 = config.events) === null || _config$events2 === void 0 || (_config$events2 = _config$events2.eventsSection) === null || _config$events2 === void 0 ? void 0 : _config$events2.headingClass) || '', "\n  "),
      children: "PAST EVENTS"
    }), ComponentsRenderer && /*#__PURE__*/_jsx(ComponentsRenderer, {
      components: config === null || config === void 0 ? void 0 : config.events.eventsSection.components
    }), (pastEvents.length > 0 || selectedCategories.length > 0) && /*#__PURE__*/_jsx("h1", {
      className: " ".concat(config !== null && config !== void 0 && config.darkMode ? 'text-[#9b9b9b]' : 'text-black', "  self-center text-center text-xl mt-5\n                  ").concat(config === null || config === void 0 || (_config$events3 = config.events) === null || _config$events3 === void 0 ? void 0 : _config$events3.fontBody, " \n                  ").concat((config === null || config === void 0 || (_config$events4 = config.events) === null || _config$events4 === void 0 || (_config$events4 = _config$events4.eventsSection) === null || _config$events4 === void 0 ? void 0 : _config$events4.filterHeadingClass) || '', "\n                "),
      children: "BROWSE EVENT CATEGORIES"
    }), FilterOptions && ((pastEvents === null || pastEvents === void 0 ? void 0 : pastEvents.length) > 0 || (selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.length) > 0) && /*#__PURE__*/_jsx(FilterOptions, {
      selectedCategories: selectedCategories,
      onFilterClick: onFilterClick,
      type: "EVENT",
      config: config,
      color: "black",
      hideCashbackButton: true
    })]
  });
}
export default EventsSectionDescription;